import { searchTypeOption } from '@/config/config';
import { newWin } from '@/utils/index.js';
import { User, Avatar, Upload, Tickets, Ticket, Star } from '@element-plus/icons-vue';
import Cookies from 'cookies-js';
import HistoryList from '@/components/HistoryList.vue';
const getPvi = () => {
  const pvi = Cookies.get('pgv_pvi');
  if (pvi) {
    return pvi;
  }
  const _pvi = Math.round(2147483647 * (Math.random() || 0.5)) * +new Date() % 1e10;
  const year50 = 60 * 60 * 24 * 365 * 50;
  Cookies.set('pgv_pvi', _pvi, {
    domain: '.vlian.cn',
    expires: year50
  });
  return _pvi;
};
export default {
  components: {
    HistoryList,
    User,
    Avatar,
    Upload,
    Tickets,
    Ticket,
    Star
  },
  data() {
    return {
      title: [{
        title: '交易',
        url: '/'
      }, {
        title: '登记',
        url: '/copyright/registration/',
        hot: 'hot'
      }, {
        title: '保护',
        url: '/copyright/protection/'
      }, {
        title: '网剧备案',
        url: 'https://wangluoshiting.vlian.cn:8130/',
        target: '_blank'
      }, {
        title: '华中版权',
        url: 'https://huazhongbanquan.vlian.cn/',
        target: '_blank'
      },
      // { title: '云展云销', url: 'https://cscm.vlian.cn/', target: '_blank' },
      // { title: '版权转让', url: '/copyright/market/' },
      {
        title: '社区',
        url: 'https://community.vlian.cn/'
      }],
      scrollTop: 0,
      isShowType: true,
      isFixed: !['Index', 'CopyRight', 'CopyRightDeposit', 'CopyRightCheckin', 'CopyRightMonitor', 'CopyRightVerify', 'SignCreator', 'InviteImg', 'InviteCompany', 'Cooperation', 'CopyRightVip', 'CopyRightProtection'].includes(this.$route.name),
      isCy: ['CopyRight'].includes(this.$route.name),
      isDeposit: ['CopyRightDeposit', 'CopyRightCheckin', 'CopyRightMonitor', 'CopyRightVerify', 'SignCreator', 'InviteImg', 'InviteCompany', 'Cooperation', 'CopyRightVip', 'CopyRightProtection'].includes(this.$route.name),
      showUserDialog: false,
      defaultIcon: require('@/assets/image/default-avatar.jpeg'),
      searchTypeOption,
      searchType: '',
      keyword: '',
      showDrop: false,
      dropList: [{
        name: '视频',
        img: 'https://static.vlian.cn:8090/upload/fe/pc/index/视频.png',
        url: '/video/'
      }, {
        name: '图片',
        img: 'https://static.vlian.cn:8090/upload/fe/pc/index/图片.png',
        url: '/image/'
      }, {
        name: '节目购',
        img: 'https://static.vlian.cn:8090/upload/fe/pc/index/节目购.png',
        url: 'http://www.jiemugo.com'
      }, {
        name: '淘剧淘',
        img: 'https://static.vlian.cn:8090/upload/fe/pc/index/淘剧淘.png',
        url: 'http://www.taojutao.com'
      }],
      showCopyrightDrop: false,
      copyrightDropList: [{
        name: '区块链存证',
        img: 'https://static.vlian.cn:8090/upload/fe/pc/index/区块链确权.png',
        url: '/copyright/registration/#chain'
      }, {
        name: '版权登记',
        img: 'https://static.vlian.cn:8090/upload/fe/pc/index/版权登记.png',
        url: '/copyright/registration/#reg'
      }, {
        name: 'DCI申领',
        img: 'https://static.vlian.cn:8090/upload/fe/pc/index/DCI申领.png',
        url: '/copyright/registration/#dci'
      }, {
        name: '知产溯源',
        img: 'https://static.vlian.cn:8090/upload/fe/pc/index/知产溯源.png',
        url: '/copyright/trace/'
      }],
      showCopyrightProtectionDrop: false,
      copyrightDropList2: [{
        name: '图片监测',
        img: 'https://static.vlian.cn:8090/upload/fe/pc/index/图片监测.png',
        url: '/copyright/protection/#montior1'
      }, {
        name: '视频监测',
        img: 'https://static.vlian.cn:8090/upload/fe/pc/index/视频监测.png',
        url: '/copyright/protection/#montior2'
      }, {
        name: '公众号监测',
        img: 'https://static.vlian.cn:8090/upload/fe/pc/index/公众号监测.png',
        url: '/copyright/protection/#montior3'
      }, {
        name: '电商监测',
        img: 'https://static.vlian.cn:8090/upload/fe/pc/index/电商监测.png',
        url: '/copyright/protection/#montior4'
      }, {
        name: '数字公证',
        img: 'https://static.vlian.cn:8090/upload/fe/pc/index/数字公证.png',
        url: '/copyright/protection/#evidence'
      }],
      showUploadDialog: false,
      allItemCount: false,
      imgList: [],
      showUserHistory: false
    };
  },
  watch: {
    $route(newVal) {
      if (['Index', 'CopyRight', 'CopyRightDeposit', 'CopyRightCheckin', 'CopyRightMonitor', 'CopyRightVerify', 'SignCreator', 'InviteImg', 'InviteCompany', 'Cooperation', 'CopyRightProtection'].includes(newVal.name)) {
        this.routeChange();
      } else {
        window.removeEventListener('scroll', this.handleScroll, true);
        this.isFixed = true;
      }
    }
  },
  computed: {
    isShowSearchBox() {
      const noSearchInputRouter = ['Index', 'Search', 'CopyRightProtection'];
      return !noSearchInputRouter.includes(this.$route.name);
    },
    uploadUrl() {
      if (this.allItemCount) {
        return '/creator/upload';
      } else {
        return '/signCreator';
      }
    },
    active() {
      console.log(this.$route.name);
      if (['CopyRightProtection', 'CopyRightMonitor', 'WebEvidence'].includes(this.$route.name)) {
        return 2;
      } else {
        return this.$route.path.indexOf('copyright') > -1 ? 1 : -1;
      }
    },
    topQuery() {
      const {
        bd_vid
      } = this.$route.query;
      return bd_vid ? {
        bd_vid
      } : {};
    }
  },
  mounted() {
    this.getUserInfo();
    this.routeChange();
    this.getAnalysis();
    this.getAlyToken();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll, true);
  },
  methods: {
    getAlyToken() {
      this.$service.ApiAliGetToken({
        pvi: getPvi()
      }).then(res => {
        localStorage.setItem('alyToken', res.data);
      }).catch(err => {
        console.log(err);
      });
    },
    getUserInfo() {
      this.$service.ApiCommonGetUserInfo({}).then(res => {
        var _res$data;
        if ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.photo.length) < 40) {
          res.data.photo = '';
        }
        this.$setUserInfo(res.data);
        this.getOpenUploadUrl();
      }).catch(() => {
        this.getOpenUploadUrl();
      });
    },
    cki(item) {
      // if (item.title == 'V链社区') {
      //   ElMessage.success('V链社区内测中，即将上线，敬请期待');
      // } else {
      window.location.href = item.url;
      // }
    },

    routeChange() {
      if (['Index', 'CopyRight', 'CopyRightDeposit', 'CopyRightCheckin', 'CopyRightMonitor', 'CopyRightVerify', 'SignCreator', 'InviteImg', 'InviteCompany', 'Cooperation', 'CopyRightProtection'].includes(this.$route.name)) {
        window.addEventListener('scroll', this.handleScroll, true);
      } else {
        this.isFixed = true;
      }
    },
    // 保存滚动值，这是兼容的写法
    handleScroll() {
      const HEADER_HEIGHT = 65;
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.isFixed = this.scrollTop > HEADER_HEIGHT;
    },
    login() {
      this.$login().then(res => {
        console.log('登录成功', res);
        window.location.reload();
      }).catch(err => {
        console.log('登录失败', err);
      });
    },
    logout() {
      this.$setUserInfo({});
      this.$setToken('');
      Cookies.set('token1', '', {
        path: '/',
        domain: '.vlian.cn'
      });
      Cookies.set('token', '', {
        path: '/',
        domain: '.vlian.cn'
      });
      this.$service.ApiCommonLogout().then(() => {
        window.location.reload();
      }).catch(() => {});
    },
    onSearch() {
      if (this.searchType == 11) {
        newWin(`/image/search/?keyword=${this.keyword}&type=${this.searchType}&fpos=HeaderPage`);
      } else {
        newWin(`/search/?keyword=${this.keyword}&type=${this.searchType}&fpos=HeaderPage`);
      }
      // let routeInfo = this.$router.resolve({
      //   path: `/search`,
      //   query: { ...this.$route.query, keyword: this.keyword, type: this.searchType, fpos: this.dataPart || this.$route.name || '' },
      // });
    },

    dropMouseEnter(index) {
      this.showDrop = index === 0 ? true : false;
      this.showCopyrightDrop = [1].includes(index);
      this.showCopyrightProtectionDrop = [2].includes(index);
    },
    dropMouseLeave() {
      this.showDrop = false;
      this.showCopyrightDrop = false;
      this.showCopyrightProtectionDrop = false;
    },
    dropCki(item) {
      if (item.path) {
        let routeInfo = this.$router.resolve({
          path: item.path,
          query: {
            ...this.query.query
          }
        });
        newWin(routeInfo.href);
        return;
      }
      newWin(item.url);
    },
    // 只要用户一直没上传过素材，就一直会有这个中间页，一旦用户上传过素材了，就直接进入上传页面
    getOpenUploadUrl() {
      this.$service.ApiUserUserItemCount().then(res => {
        var _res$data2;
        this.allItemCount = res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.allItemCount;
      }).catch(() => {});
    },
    getAnalysis() {
      let params = {
        page: 1,
        pageSize: 10
      };
      this.$service.ApiHistoryGetBrowsingHistory({
        ...params
      }).then(res => {
        var _res$data3;
        this.imgList = res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.items;
      }).catch(() => {});
    },
    enterHistory() {
      let routeInfo = this.$router.resolve({
        path: '/account/historyList',
        query: {
          ...this.$route.query
        }
      });
      newWin(routeInfo.href);
    }
  }
};